import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';

export function AnimatedAIIcon({ animate = true }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '48px',
        height: '48px'
      }}
    >
      <svg width="48" height="48" viewBox="-1 0 19 14" xmlns="http://www.w3.org/2000/svg">
        <motion.path
          d="M1.1484 10.3056C1.17663 10.3446 1.21646 10.3738 1.26222 10.389L2.49024 10.798C2.76023 10.8879 3.00556 11.0395 3.20679 11.2408C3.40802 11.442 3.55962 11.6873 3.64957 11.9573L4.05856 13.1853C4.07372 13.2311 4.10291 13.2709 4.14199 13.2992C4.18107 13.3274 4.22806 13.3426 4.27627 13.3426C4.32448 13.3426 4.37146 13.3274 4.41054 13.2992C4.44962 13.2709 4.47882 13.2311 4.49397 13.1853L4.90296 11.9573C4.99291 11.6873 5.14451 11.442 5.34574 11.2408C5.54697 11.0395 5.7923 10.8879 6.06229 10.798L7.29031 10.389C7.33608 10.3738 7.3759 10.3446 7.40413 10.3056C7.43236 10.2665 7.44755 10.2195 7.44755 10.1713C7.44755 10.1231 7.43236 10.0761 7.40413 10.037C7.3759 9.99793 7.33608 9.96874 7.29031 9.95358L6.06229 9.5446C5.7923 9.45464 5.54697 9.30304 5.34574 9.10182C5.14451 8.90059 4.99291 8.65526 4.90296 8.38527L4.49397 7.15724C4.47882 7.11148 4.44962 7.07165 4.41054 7.04342C4.37146 7.01519 4.32448 7 4.27627 7C4.22806 7 4.18107 7.01519 4.14199 7.04342C4.10291 7.07165 4.07372 7.11148 4.05856 7.15724L3.64957 8.38527C3.46674 8.9327 3.03768 9.36177 2.49024 9.5446L1.26222 9.95358C1.21646 9.96874 1.17663 9.99793 1.1484 10.037C1.12017 10.0761 1.10498 10.1231 1.10498 10.1713C1.10498 10.2195 1.12017 10.2665 1.1484 10.3056Z"
          fill="currentColor"
          animate={
            animate
              ? {
                  scale: [1, 1.2, 1],
                  opacity: [0.7, 1, 0.7]
                }
              : {
                  scale: 1,
                  opacity: 1
                }
          }
          transition={
            animate
              ? {
                  duration: 1.5,
                  repeat: Infinity,
                  ease: 'easeInOut',
                  delay: 0
                }
              : {
                  duration: 0
                }
          }
        />
        <motion.path
          d="M6.64584 5.58033C6.29709 5.69658 6.29709 6.18906 6.64584 6.30531L8.6929 6.98696C9.14278 7.13689 9.55157 7.38952 9.88688 7.72484C10.2222 8.06015 10.4748 8.46894 10.6248 8.91882L11.3064 10.9659C11.3315 11.0422 11.38 11.1087 11.4451 11.1559C11.5102 11.203 11.5885 11.2284 11.6689 11.2284C11.7493 11.2284 11.8276 11.203 11.8927 11.1559C11.9578 11.1087 12.0063 11.0422 12.0314 10.9659L12.713 8.91882C12.863 8.46894 13.1156 8.06015 13.4509 7.72484C13.7862 7.38952 14.195 7.13689 14.6449 6.98696L16.692 6.30531C16.7683 6.28025 16.8348 6.23171 16.882 6.16661C16.9291 6.10152 16.9545 6.0232 16.9545 5.94282C16.9545 5.86245 16.9291 5.78413 16.882 5.71903C16.8348 5.65394 16.7683 5.6054 16.692 5.58033L14.646 4.89869C14.1959 4.74889 13.7869 4.49633 13.4514 4.161C13.1159 3.82568 12.8631 3.41682 12.713 2.96682L12.0314 0.919766C11.9151 0.571016 11.4227 0.571016 11.3064 0.919766L10.6248 2.96577C10.475 3.41584 10.2224 3.82484 9.88708 4.16035C9.55175 4.49586 9.14289 4.74865 8.6929 4.89869L6.64584 5.58033Z"
          fill="currentColor"
          animate={
            animate
              ? {
                  scale: [1, 0.8, 1],
                  opacity: [0.7, 1, 0.7]
                }
              : {
                  scale: 1,
                  opacity: 1
                }
          }
          transition={
            animate
              ? {
                  duration: 1.5,
                  repeat: Infinity,
                  ease: 'easeInOut',
                  delay: 0.5
                }
              : {
                  duration: 0
                }
          }
        />
        <motion.path
          d="M0.0738003 2.85911C0.0922675 2.88506 0.118361 2.90461 0.148452 2.91504H0.149509L0.966429 3.18664C1.33209 3.30818 1.61849 3.59458 1.74002 3.96024L2.01268 4.77821C2.02311 4.8083 2.04266 4.8344 2.06861 4.85286C2.09456 4.87133 2.12561 4.88125 2.15746 4.88125C2.18931 4.88125 2.22037 4.87133 2.24632 4.85286C2.27227 4.8344 2.29182 4.8083 2.30225 4.77821L2.57491 3.96129C2.63485 3.78109 2.73598 3.61735 2.87027 3.48306C3.00455 3.34878 3.1683 3.24765 3.3485 3.1877L4.16647 2.91504C4.19657 2.90461 4.22266 2.88506 4.24113 2.85911C4.25959 2.83316 4.26952 2.80211 4.26952 2.77026C4.26952 2.73841 4.25959 2.70735 4.24113 2.6814C4.22266 2.65546 4.19657 2.63591 4.16647 2.62547L3.3485 2.35281C3.1683 2.29287 3.00455 2.19174 2.87027 2.05745C2.73598 1.92317 2.63485 1.75942 2.57491 1.57922L2.30225 0.761246C2.29182 0.731154 2.27227 0.705061 2.24632 0.686594C2.22037 0.668127 2.18931 0.658203 2.15746 0.658203C2.12561 0.658203 2.09456 0.668127 2.06861 0.686594C2.04266 0.705061 2.02311 0.731154 2.01268 0.761246L1.74002 1.57922C1.61849 1.94488 1.33209 2.23128 0.966429 2.35281L0.148452 2.62547C0.118361 2.63591 0.0922675 2.65546 0.0738003 2.6814C0.0553331 2.70735 0.0454102 2.73841 0.0454102 2.77026C0.0454102 2.80211 0.0553331 2.83316 0.0738003 2.85911Z"
          fill="currentColor"
          animate={
            animate
              ? {
                  scale: [1, 1.3, 1],
                  opacity: [0.7, 1, 0.7]
                }
              : {
                  scale: 1,
                  opacity: 1
                }
          }
          transition={
            animate
              ? {
                  duration: 1.5,
                  repeat: Infinity,
                  ease: 'easeInOut',
                  delay: 1
                }
              : {
                  duration: 0
                }
          }
        />
      </svg>
    </div>
  );
}
AnimatedAIIcon.propTypes = {
  animate: PropTypes.bool
};

// function AnimatedAIIcon() {
//   return (
//     <svg width="48" height="48" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
//       <motion.path
//         d="M405.2 521.9C394.3 518 386.9 507.6 386.9 496 386.9 484.4 394.3 474 405.1 470.1L455.1 452.1C504.4 434.3 542.9 395.8 560.7 346.5L578.7 296.6C582.6 285.7 593 278.4 604.5 278.4 616.1 278.4 626.5 285.7 630.4 296.6L648.4 346.5C666.2 395.9 704.7 434.3 754 452.1L804 470.1C814.9 474 822.2 484.4 822.2 496 822.2 507.6 814.9 518 804 521.9L754 539.9C704.7 557.7 666.2 596.2 648.5 645.5L630.4 695.5C626.5 706.3 616.1 713.7 604.6 713.7 593 713.7 582.6 706.3 578.7 695.5L560.7 645.5C542.9 596.2 504.4 557.7 455.1 539.9L405.2 521.9ZM470.3 497.8C532.2 520.1 580.5 568.4 602.8 630.3L604.6 635.2 606.3 630.3C628.7 568.4 677 520.1 738.9 497.8L743.7 496 738.9 494.3C676.9 472 628.6 423.6 606.3 361.7L604.6 356.9 602.8 361.7C580.5 423.6 532.2 472 470.3 494.3L465.4 496 470.3 497.8Z"
//         fill="currentColor"
//         animate={{
//           scale: [1, 0.6, 1],
//           opacity: [0.7, 0.8, 0.7]
//         }}
//         transition={{
//           duration: 1.5,
//           repeat: Infinity,
//           ease: 'easeInOut',
//           delay: 0
//         }}
//       />
//       <motion.path
//         d="M322 400.8L296.7 409.9C274.9 417.8 257.8 434.8 249.9 456.7L240.8 482C237.3 491.9 227.8 498.5 217.3 498.5 206.8 498.5 197.3 491.9 193.8 482L184.7 456.7C176.8 434.8 159.7 417.8 137.9 409.9L112.5 400.8C102.7 397.2 96.1 387.8 96 377.3 96 366.9 102.6 357.4 112.5 353.8L137.9 344.6C159.7 336.8 176.8 319.7 184.7 297.8L193.8 272.5C197.4 262.6 206.8 256 217.3 256 227.8 256 237.3 262.7 240.8 272.5L249.9 297.8C257.8 319.7 274.9 336.8 296.7 344.6L322.1 353.8C332 357.4 338.6 366.8 338.6 377.3 338.5 387.8 331.9 397.2 322 400.8ZM217.3 333.4C206.7 351.6 191.6 366.7 173.4 377.3 191.6 387.9 206.7 402.9 217.3 421.1 227.9 402.9 243 387.8 261.1 377.3 243 366.6 227.9 351.6 217.3 333.4Z"
//         fill="currentColor"
//         animate={{
//           scale: [1, 1.4, 1],
//           opacity: [0.7, 1, 0.7]
//         }}
//         transition={{
//           duration: 1.5,
//           repeat: Infinity,
//           ease: 'easeInOut',
//           delay: 0.5
//         }}
//       />
//       <motion.path
//         d="M208.6 655.3L233.9 646.1C255.8 638.3 272.8 621.2 280.7 599.3L289.8 574C293.4 564.2 302.8 557.5 313.4 557.5 323.9 557.5 333.3 564.2 336.9 574L346 599.3C353.9 621.2 370.9 638.3 392.8 646.1L418.1 655.2C427.9 658.8 434.6 668.2 434.6 678.7 434.6 689.2 428 698.7 418.1 702.3L392.8 711.4C370.9 719.3 353.8 736.3 346 758.2L336.9 783.5C333.3 793.4 323.9 800 313.3 800 302.8 800 293.3 793.4 289.8 783.5L280.7 758.2C272.8 736.3 255.7 719.3 233.9 711.4L208.5 702.2C198.6 698.6 192 689.2 192.1 678.7 192.1 668.2 198.8 658.8 208.6 655.3ZM313.3 722.6C323.9 704.4 339 689.4 357.2 678.8 339 668.2 323.9 653.1 313.3 634.9 302.7 653.1 287.6 668.2 269.5 678.8 287.6 689.4 302.7 704.5 313.3 722.6Z"
//         fill="currentColor"
//         animate={{
//           scale: [1, 1.4, 1],
//           opacity: [0.7, 1, 0.7]
//         }}
//         transition={{
//           duration: 1.5,
//           repeat: Infinity,
//           ease: 'easeInOut',
//           delay: 1
//         }}
//       />
//     </svg>
//   );
// }
